export type EntityStateLoader<T> = {
  invalidate: () => void;
  load: () => Promise<T>;
};

// Shares one state request between the Status pill and the PlayButton of a list row. The initial
// promise is reused until the state is invalidated (after pause/resume/sync) or the request fails,
// so refetches after a user action hit the backend instead of re-reading the list-time snapshot.
export function createEntityStateLoader<T>(request: () => Promise<T>, initial?: Promise<T>): EntityStateLoader<T> {
  let current: Promise<T> | null = null;

  const track = (promise: Promise<T>) => {
    current = promise;
    promise.catch(() => {
      if (current === promise) {
        current = null;
      }
    });
    return promise;
  };

  track(initial ?? request());

  return {
    invalidate: () => {
      current = null;
    },
    load: () => current ?? track(request())
  };
}
